module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.Account.IsCoveredUnderHIPAA) ? _c('div', {
    staticClass: "registration-title"
  }, [_vm._v("\n        Terms & Conditions and BAA\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Account.IsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "g-mb-0"
  }, [_c('small', [_vm._v("Please review and accept the below in connection with your\n          registration and participation in the OneSight EssilorLuxottica\n          Foundation's Champions for Sight® program: (i) Terms and Conditions\n          to the Changing Life through Lenses® Agreement (related to the\n          online charitable glasses and resources tool), (ii) Business\n          Associate Agreement (“BAA”) (collectively, the \"Champions for Sight®\n          Contract\"), and (iii) Terms and Conditions to the Grateful Patient™\n          Point of Sale Giving Agreement (related to the point of sale giving\n          campaign tool).")])]) : _vm._e(), _vm._v(" "), (!_vm.Account.IsCoveredUnderHIPAA) ? _c('p', {
    staticClass: "g-mb-0"
  }, [_vm._v("\n        Please review and accept the below Terms and Conditions or\n        "), _c('a', {
    staticClass: "g-font-size-18",
    attrs: {
      "href": "https://drive.google.com/open?id=1DcjwlGpVIiO25W09ai5eVpA8qt-ApTRN",
      "target": "_blank"
    }
  }, [_vm._v("click here")]), _vm._v("\n        to download a copy.\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    attrs: {
      "type": "radio",
      "value": "true",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "true")
    },
    on: {
      "click": function($event) {
        return _vm.EnableTermAndAgreementSubmitBtn(4, false)
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "true")
      }
    }
  }), _vm._v("\n          I have read and AGREE to all of the above\n          "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.TermAgreement),
      expression: "Account.TermAgreement"
    }],
    attrs: {
      "type": "radio",
      "value": "false",
      "name": "TermAgreement"
    },
    domProps: {
      "checked": _vm._q(_vm.Account.TermAgreement, "false")
    },
    on: {
      "click": function($event) {
        return _vm.EnableTermAndAgreementSubmitBtn(4, true)
      },
      "change": function($event) {
        return _vm.$set(_vm.Account, "TermAgreement", "false")
      }
    }
  }), _vm._v("\n          I DO NOT AGREE to all the above\n        ")])]), _vm._v(" "), (
    _vm.agreementOptions.termsAndCondition[4] &&
    _vm.Account.TermAgreement != null
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        You must select \"I Agree\" to submit the form. Please click\n        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModalTAC()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions\n        or concerns\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isModalShownTAC) ? _c('div', [_c('portal-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div",
    attrs: {
      "hidden": ""
    }
  }, [_c('p', [_vm._v("\n        By selecting, “I DO NOT AGREE”, you will not be able to complete your\n        registration for a portal account. If you have any questions or\n        concerns, please send us an email below.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Name),
      expression: "TermsEmail.Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.TermsEmail.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Email),
      expression: "TermsEmail.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.TermsEmail.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please Enter Message Below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TermsEmail.Message),
      expression: "TermsEmail.Message"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.TermsEmail.Message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.TermsEmail, "Message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn"
  }, [_c('button', {
    staticClass: "evf-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitEmail(1)
      }
    }
  }, [_vm._v("\n            Send\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Electronic Signature*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ParticipantResponsibilitiesSignature),
      expression: "Account.ParticipantResponsibilitiesSignature"
    }],
    staticClass: "form-control",
    class: {
      error_field:
        _vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature,
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.ParticipantResponsibilitiesSignature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "ParticipantResponsibilitiesSignature", $event.target.value)
      }
    }
  }), _vm._v(" "), (
    _vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.AccountValidationResult.AccountParticipantResponsibilitiesSignature) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Date*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ParticipantResponsibilitiesDate),
      expression: "Account.ParticipantResponsibilitiesDate"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.Account.ParticipantResponsibilitiesDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account, "ParticipantResponsibilitiesDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    _vm.Account.IsCoveredUnderHIPAA == true ||
    _vm.Account.IsCoveredUnderHIPAA == null
  ) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.isModalShownBAA) ? _c('div', [_c('portal-form', {
    on: {
      "closeWufoo": function($event) {
        return _vm.CloseModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.agreementOptions.termsAndCondition[5] &&
    _vm.Account.BusinessAssociateAgreement != null
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        You must select \"I Agree\" to submit the form. Please click\n        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.ShowModalBAA()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to contact us with questions\n        or concerns\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Account.BusinessAssociateAgreement == false) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div",
    attrs: {
      "hidden": ""
    }
  }, [_c('p', [_vm._v("\n          By selecting, “I DO NOT AGREE”, you will not be able to complete\n          your registration for a portal account. If you have any questions or\n          concerns, please send us an email below.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Name),
      expression: "BusinessEmail.Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.BusinessEmail.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Email),
      expression: "BusinessEmail.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.BusinessEmail.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Please Enter Message Below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BusinessEmail.Message),
      expression: "BusinessEmail.Message"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.BusinessEmail.Message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.BusinessEmail, "Message", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn"
  }, [_c('button', {
    staticClass: "evf-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitEmail(2)
      }
    }
  }, [_vm._v("\n              Send\n            ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [(
    _vm.AccountValidationResult.AccountIsCoBrandAgreed ||
    _vm.AccountValidationResult.AccountIsElectronicLogAgreed ||
    _vm.AccountValidationResult.AccountIsLensesAgreementAgreed ||
    _vm.AccountValidationResult.AccountIsPatientChargeAgreed ||
    _vm.AccountValidationResult.AccountIsValidatePatientNeedAgreed
  ) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        Please accept all agreements\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-style"
  }, [_c('div', {
    staticClass: "terms-section"
  }, [_vm._v("\n          Changing Life through Lenses® Agreement\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-bottom": "4pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Changing Life through Lenses® Terms and Conditions")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Contract Documents and")]), _vm._v(" "), _c('strong', [_vm._v("Effective Date:")]), _vm._v(" These Changing Life through\n            Lenses® Terms and Conditions (\""), _c('strong', [_vm._v("Terms and Conditions")]), _vm._v("\") supplement and are made a part of the Changing Life through\n            Lenses® Agreement (\""), _c('strong', [_vm._v("Contract")]), _vm._v("\") by and between the\n            legal entity or individual identified as the participant\n            (“"), _c('strong', [_vm._v("Participant")]), _vm._v("”) on the Champions for Sight®\n            registration form (“"), _c('strong', [_vm._v("Registration Form")]), _vm._v("”) and\n            OneSight d/b/a OneSight EssilorLuxottica Foundation\n            (\""), _c('strong', [_vm._v("Foundation”")]), _vm._v("). The Contract consists of (i)\n            these Terms and Conditions, and (ii) if applicable, the Business\n            Associate Agreement (which is set forth on the Registration Form\n            if Participant is a covered entity"), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt"
    }
  }, [_vm._v("under the ")]), _vm._v("Health\n            Insurance Portability and Accountability Act of 1996).  Your\n            use of the Changing Life through Lenses® online platform\n            (“"), _c('strong', [_vm._v("Portal")]), _vm._v("”) is also subject to the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            and\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v("\n            posted on\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org")])])]), _vm._v("; provided, that in the event of any conflict between the\n            Contract and the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            and/or\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Privacy Policy")])])]), _vm._v(", the provisions of the Contract shall prevail. Capitalized terms\n            used but not defined in these Terms and Conditions shall have the\n            meaning ascribed to them in the Registration Form.  If you\n            accept the Contract, the date on which you click the “Agree &\n            Submit” or similar button shall be the effective date of the\n            Contract (“"), _c('strong', [_vm._v("Effective Date")]), _vm._v("”).\n            "), _c('u', [_vm._v("BY CLICKING THE “SUBMIT” BUTTON, (i) YOU ARE BINDING\n              PARTICIPANT TO THE CONTRACT, THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("TERMS OF USE")])])]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("PRIVACY POLICY")])])]), _c('u', [_vm._v(", AND (ii) IF PARTICIPANT IS A LEGAL ENTITY, YOU ARE\n              REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO AGREE TO\n              THE CONTRACT, THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("TERMS OF USE")])])]), _c('u', [_vm._v(", AND THE ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/privacy-policy/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("PRIVACY POLICY")])])]), _c('u', [_vm._v(" ON BEHALF OF PARTICIPANT")]), _vm._v("."), _c('u')]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Information:")]), _vm._v(" The Foundation is a\n            non-profit organization committed to eliminating poor vision and\n            its lifelong consequences and to providing underprivileged people\n            the opportunity to live a better life through better sight. The\n            Foundation works with nonprofit organizations and socially\n            responsible vision care providers across the United States to\n            provide in-kind donations of lenses and manufacturing of glasses\n            for use by Eligible Patients (the “"), _c('strong', [_vm._v("CLTL Program")]), _vm._v("”).  “"), _c('strong', [_vm._v("Eligible Patients")]), _vm._v("” are individuals\n            (i) living at or below the poverty line; (ii) who are not covered\n            by vision insurance for the pair of glasses to be provided in\n            connection with the Program; and (iii) who could not otherwise\n            afford vision services, as reasonably determined by Participant.\n            The Foundation has created the Portal to facilitate registration\n            and participation in the CLTL Program. Participant acknowledges\n            that the current focus of the CLTL Program is on youth and agrees\n            to use reasonable efforts to provide products supplied by the\n            Foundation (including lenses and/or frames) primarily to Eligible\n            Patients who are minors.  Participant further acknowledges\n            and agrees that, upon reasonable advance notice to Participant,\n            the Foundation may from time to time revise the definition of\n            Eligible Patients and the criteria for determining eligibility.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Materials:")]), _vm._v(" The Foundation will make\n            available to Participant educational resources and materials\n            describing how Participant may conduct and optimize its charitable\n            activities in connection with the CLTL Program (“"), _c('strong', [_vm._v("CLTL Program Educational Materials")]), _vm._v("”) and may make available to Participant certain assets or\n            materials to promote Participant’s involvement in the CLTL Program\n            (“"), _c('strong', [_vm._v("CLTL Program Promotional Materials")]), _vm._v("”) (CLTL\n            Program Educational Materials and CLTL Program Promotional\n            Materials, collectively “"), _c('strong', [_vm._v("CLTL Program Materials")]), _vm._v("”). Participant may make copies of CLTL Program Educational\n            Materials solely for use by Participant and Participant’s\n            employees in connection with the CLTL Program. Participant shall\n            not copy CLTL Program Promotional Materials without the\n            Foundation’s express written approval. If Participant has an\n            opportunity to promote the CLTL Program with CLTL Program\n            Promotional Materials, upon Participant’s request, the Foundation\n            will provide Participant with the Foundation logo lock up and\n            graphic standards to be used, subject to the Foundation’s prior\n            written approval in each instance. Participant shall use CLTL\n            Program Materials solely in connection with the CLTL Program.\n            Participant shall use CLTL Program Materials as is and shall not\n            modify CLTL Program Materials in any way without the express\n            written approval of the Foundation. Participant shall not delete,\n            obscure, or alter any disclosures or any copyright notice,\n            trademarks, or other proprietary rights notices affixed to or\n            contained in the CLTL Program Materials. Upon expiration or\n            termination of the Contract, Participant shall destroy or\n            immediately return to the Foundation all CLTL Program Materials in\n            Participant’s possession.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Lenses and Frames:")]), _vm._v(" The Foundation will endeavor\n            to provide Participant with fully fabricated lenses, subject to\n            such limitations on quantity as the Foundation may determine from\n            time to time in its sole discretion, as prescribed by the\n            Participant for Eligible Patients served through Participant’s\n            charitable activities. Lenses will be fabricated to meet the\n            prescription needs of each Eligible Patient, including single\n            vision and bifocals and the use of polycarbonate materials. Lenses\n            shall be fabricated by the Foundation’s suppliers and mounted in\n            frames provided on a frame-to-come basis by Participant (“"), _c('strong', [_vm._v("Participant Frames")]), _vm._v("”), unless Participant (i) specifies lenses only (without\n            mounting) or (ii) orders a complete pair of glasses through the\n            Portal, including frames supplied by the Foundation(“"), _c('strong', [_vm._v("Foundation Frames")]), _vm._v("”), if available, in which case the Foundation’s suppliers will\n            fabricate and mount the lenses in such Foundation Frames. If\n            Foundation Frames are available, the Foundation may, in its sole\n            discretion, charge Participant a service fee for complete orders\n            (lenses with Foundation Frames). In addition, a supply of\n            Foundation Frames may be available for a service fee in order to\n            provide sample selection for display or trial by Eligible\n            Patients.  Participant is responsible for shipping\n            Participant Frames to the Foundation’s designated supplier at\n            Participant’s own expense.  Shipments of lenses and frames\n            from the Foundation or its supplier to Participant will be at no\n            cost to Participant.  For clarity, the Foundation does not\n            guarantee that Foundation Frames will be available.  If\n            available, The Foundation does not guarantee that colors of\n            Foundation Frames as depicted online will be accurately displayed.\n            The Foundation does not warrant that the Foundation Frame product\n            descriptions are accurate, complete, reliable, current or\n            error-free.  The Foundation will not be liable for\n            typographical errors and reserves the right to refuse or cancel\n            any order or service in the event of a typographical error. The\n            Foundation, in its sole discretion, shall select suppliers of CLTL\n            Program products and services and Participant may not designate\n            suppliers of its choice.  The Foundation has the right to\n            reduce or limit the number of lenses and/or frames made available\n            under this Contract at any time for any reason.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Warranty Disclaimer: ")]), _vm._v("Participant Frames may be\n            lost or damaged during the fabrication of eyeglasses.\n            Participant’s use of Participant Frames is at Participant’s own\n            risk. The Foundation, its suppliers and service providers,\n            including any laboratory used by the Foundation, shall not be\n            liable for damage to the frame due to the fabrication and shipping\n            process or for lost frames. "), _c('strong', [_vm._v(" ")]), _c('strong', [_vm._v("THE PORTAL, ALL LENSES AND FRAMES, AND ALL RELATED SERVICES ARE\n              PROVIDED ON AN \"AS IS\" BASIS, WITH ALL FAULTS AND WITHOUT\n              WARRANTY OF ANY KIND.")]), _c('strong', [_vm._v("  ")]), _c('strong', [_vm._v("THE FOUNDATION HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH\n              RESPECT TO THE PORTAL, THE LENSES AND FRAMES, AND RELATED\n              SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE\n              IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR\n              PURPOSE, QUIET ENJOYMENT, TITLE, AND NON-INFRINGEMENT, AND\n              WARRANTIES ARISING THROUGH COURSE OF DEALING OR USAGE OF\n              TRADE.")]), _c('strong', [_vm._v("  ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Additional Foundation Responsibilities:")]), _vm._v("\n            Participant agrees that the Foundation may, but is not obligated\n            to, list Participant as a CLTL Program participant on the\n            Foundation website in the same manner it lists other comparable\n            CLTL Program participants. The Foundation will submit to\n            Participant any requests for additional trademarks, copy or\n            content needed for individual events or media for the\n            Participant’s approval prior to publication.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Participant Responsibilities: ")]), _c('em', [_vm._v("In the event that Participant fails to satisfy one or more of\n              the below-referenced responsibilities, or any other Participant\n              obligation set forth in the Contract, the Foundation may, in its\n              sole discretion, offer to modify the terms of this Contract in\n              lieu of other recourse.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to promote the Foundation as a charitable\n            sponsor and to co-brand any marketing or promotional materials\n            prepared by Participant related to Participant’s charitable\n            services in connection with the CLTL Program, provided that\n            Participant agrees to submit to The Foundation Any such co-branded\n            materials, including copy or content for individual events or\n            media, for the Foundation’s written approval prior to publication\n            or other distribution. Participant will not use the Foundation\n            name, logo or other intellectual property without the prior\n            written approval of the Foundation.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to use the CLTL Program, and any lenses,\n            frames, and related services ordered through the Portal or ordered\n            in connection with the CLTL Program solely for charitable vision\n            services to Eligible Patients and to validate patient eligibility\n            in accordance with criteria established by the Foundation from\n            time to time.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees that Participant will not charge Eligible\n            Patients for the lens product delivered; however, Participant may\n            charge Eligible Patients up to, but not to exceed, the actual cost\n            of the frame paid by Participant.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-left": "36pt",
      "margin-bottom": "0pt",
      "text-indent": "-18pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n          ●"), _c('span', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("        ")]), _c('strong', [_vm._v("Participant agrees to retain an Electronic Health Record (EHR) or\n            an electronic log containing, at a minimum, the following\n            information:")]), _c('strong', [_vm._v("  ")]), _c('strong', [_vm._v("for each Eligible Patient, the date of service, number/name of\n            patient examined, and how eligibility was validated; the number of\n            exams provided; the number of Eligible Patients who received\n            glasses; the number of glasses dispensed; and the number of\n            Eligible Patients receiving glasses for the first time. The\n            electronic log must be kept current and made available to the\n            Foundation as the Foundation may request from time to time during\n            the Term (as defined below) and for one year thereafter for audit\n            purposes and other treatment and health care operation purposes\n            further described in any applicable Business Associate Agreement.\n          ")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "8",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Marks:")]), _vm._v(" Participant acknowledges the Foundation’s\n            right, title, and interest in its trade names, trademark, trade\n            dress, logos, and other indicia of origin owned or licensed by the\n            Foundation (the “"), _c('strong', [_vm._v("the Foundation Marks")]), _vm._v("”).\n            Participant is authorized to use the Foundation Marks solely as\n            the Foundation Marks are incorporated into the CLTL Program\n            Materials or as otherwise approved by the Foundation in writing in\n            connection with the CLTL Program and shall not use the Foundation\n            Marks for any other purpose. Participant acknowledges and agrees\n            that the Foundation or its licensor, as applicable, retains all\n            ownership rights in the Foundation Marks and that the benefit of\n            use of the Foundation Marks hereunder, as well as all trademark\n            and other intellectual property rights stemming therefrom, shall\n            inure and belong solely to the Foundation or its licensor, as\n            applicable. Participant agrees to cease use of the Foundation\n            Marks immediately upon the Foundation’s request or termination of\n            this Contract. Participant will not attempt to obtain a copyright\n            or trademark in any artwork that contains or is derived from the\n            Foundation Marks without the Foundation’s prior written consent.\n            Participant grants to the Foundation a limited, non-exclusive\n            license to use the Participant name and logo, together with the\n            brand names, logos, and images otherwise provided or authorized by\n            Participant, (the “Participant Marks”) for the sole purpose of\n            promoting the CLTL Program and acknowledging Participant’s\n            participation in the CLTL Program; provided, however, that any\n            other use by the Foundation of intellectual property rights owned\n            by Participant requires Participant’s prior written authorization.\n            Upon request, Participant shall provide the Foundation with high\n            resolution images of Participant’s logo.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("No Endorsement:")]), _vm._v(" Participant shall in no way\n            suggest endorsement by the Foundation of Participant or\n            Participant’s products or services.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Permission to Link:")]), _vm._v(" During the Term, (i) the\n            Foundation grants Participant permission to provide a link from\n            Participant’s Web site to the Foundation’s Web site, which\n            permission the Foundation may withdraw at any time and for any\n            reason; and (ii) Participant grants the Foundation permission to\n            provide a link from the Foundation’s Web site to Participant’s Web\n            site, which permission Participant may withdraw at any time and\n            for any reason. Neither party shall have an obligation to provide\n            a link from its Web site to the Web site of the other party.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of the Foundation:")]), _vm._v("\n            The Foundation represents and warrants to Participant that it has\n            the right, power, and authority to enter into this Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of Participant:")]), _vm._v("\n            Participant represents and warrants to the Foundation that: (i) it\n            has the right, power, and authority to enter into this Contract;\n            (ii) it will comply with all applicable federal, state, and local\n            laws, statutes, ordinances, and regulations (collectively,\n            “"), _c('strong', [_vm._v("Laws")]), _vm._v("”) in connection with the CLTL Program and\n            this Contract, including Laws related to professional licensure\n            and the provision of vision care services; and (iii) any valid\n            lens prescription ordered before expiration date noted on the\n            prescription submitted by Participant have been prescribed by duly\n            licensed professionals.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Indemnity:")]), _vm._v(" Participant agrees to indemnify and\n            hold the Foundation, its suppliers, and each of their directors,\n            officers, employees, agents, representatives, and volunteers,\n            harmless from and against any and all costs, losses, and expenses,\n            including reasonable attorneys’ fees, that the Foundation may\n            incur by reason of any claims, actions, demands, or law suits\n            brought by a third party arising out of, or in connection with (i)\n            Participant’s negligence, recklessness, or intentional misconduct;\n            (ii) Participant’s performance or failure to perform pursuant to\n            this Contract, including breach of any provision of this Contract;\n            or (iii) Participant’s location(s), business, products, or\n            services, including any claims in the nature of product liability,\n            personal injury, or professional malpractice.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Term and Termination:")]), _vm._v(" This Contract shall\n            commence on the Effective Date and will continue until terminated\n            in accordance herein (the “"), _c('strong', [_vm._v("Term")]), _vm._v("”). Unless\n            otherwise mutually agreed by the parties, the Contract shall\n            automatically terminate upon the termination of any applicable\n            Business Associate Agreement. Either party may terminate this\n            Contract: (i) upon any material breach of the Contract by the\n            other party, if such breach is not remedied to the reasonable\n            satisfaction of the non-breaching party within fifteen (15) days\n            after the non-breaching party provides written notice of the\n            breach to the other party; (ii) immediately upon written notice to\n            the other party whenever the notifying party in its reasonable\n            discretion determines that the continuation of the Contract will\n            damage its reputation or good will; or (iii) upon fifteen (15)\n            days written notice for convenience. In addition, the Foundation\n            may terminate the Contract (i) immediately upon written notice to\n            Participant in the event the Foundation discontinues the CLTL\n            Program, or (ii) if the Foundation revises the Contract or any\n            portion thereof (including provisions of the Terms and Conditions\n            and/or, if applicable, the Business Associate Agreement) and\n            Participant does not agree to the revised Contract within the time\n            allowed by the Foundation.  Upon termination of this\n            Contract, Participant shall immediately (A) cease to use the CLTL\n            Program Materials and the Foundation Marks, (B) discontinue any\n            new orders (The Foundation will honor any orders for lenses or the\n            fabrication of lenses received prior to the effective date of\n            termination), (C) discontinue references in any manner to its\n            relationship with the Foundation, and (D) retain the electronic\n            audit log referenced in Section 7 above for one year following\n            termination of the Contract. For purposes of this Section 14,\n            Participant’s breach of any of Participant’s obligations set forth\n            in Section 7 above shall be deemed a material breach of this\n            Contract. The provisions of this Section shall not preclude the\n            parties from seeking any other remedies available to them under\n            this Contract and applicable law. The Sections regarding Warranty\n            Disclaimer, Indemnity, Governing Law and Venue, Limitation of\n            Liability, Notices, and Miscellaneous shall survive termination of\n            this Contract. In addition, any provision which would, by its\n            nature, survive the termination of this Contract, shall do so.\n          ")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "start": "15",
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Disputes; Governing Law and Venue:")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to the Contract, the\n                CLTL Program, or the Portal shall be governed by the “Disputes\n                with OneSight EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to\n                Arbitrate set forth in the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])]), _vm._v("\n            are determined not to apply to a dispute between the parties, (i)\n            this Contract shall be governed by and construed in accordance\n            with the laws of the state of Texas, without regard to principles\n            of conflict or choice of law; and (ii) any dispute arising out of\n            or in connection with this Contract shall be filed and heard in\n            the state or federal courts located in Dallas, Texas, and the\n            parties consent to the exclusive jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Relationship of Parties:")]), _vm._v(" The parties to this\n            Contract are not joint venturers, partners, agents, or\n            representatives of each other, are not authorized to act on each\n            other’s behalf, and have no legal relationship other than as\n            independent contracting parties to this Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Assignment:")]), _vm._v(" No party may assign this Contract, or\n            any rights or obligations hereunder, without the prior written\n            consent of the other party. Notwithstanding the foregoing, in the\n            event that any license agreement between the Foundation and its\n            licensor is terminated, the Foundation may, without Participant’s\n            consent, assign its rights and obligations with respect to any\n            sublicense granted hereunder to such licensor. Any attempt to\n            assign this Contract in contravention of this Section shall be\n            void and of no force and effect. This Contract is binding upon and\n            will inure to the benefit of the respective parties hereto and\n            their successors and permitted assigns.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Limitation of Liability:")]), _vm._v(" EXCEPT WITH RESPECT TO\n            INDEMNIFICATION OBLIGATIONS SET FORTH HEREIN, NEITHER PARTY SHALL\n            BE LIABLE TO THE OTHER FOR ANY (I) DIRECT DAMAGES, IN THE\n            AGGREGATE, IN EXCESS OF $100.00, OR (II) INDIRECT, SPECIAL,\n            CONSEQUENTIAL, INCIDENTAL, OR PUNITIVE DAMAGE WITH RESPECT TO ANY\n            CLAIM ARISING OUT OF THIS CONTRACT (INCLUDING ITS PERFORMANCE OR\n            BREACH OF THESE TERMS AND CONDITIONS) FOR ANY REASON.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Notices:")]), _vm._v(" All notices required or permitted to be\n            given hereunder shall be in writing and shall be sent by (i)\n            personal or courier delivery, (ii) electronic mail, or (iii) USPS\n            certified mail, postage prepaid, return receipt requested. All\n            notices to Participant shall be forwarded to Participant and/or\n            the Primary Contact designated by Participant at the principal\n            mailing address and/or email address provided for Participant when\n            completing the Registration Form, or to such other person or\n            address as Participant may designate in writing to the Foundation\n            for this purpose. All notices to the Foundation shall be forwarded\n            to OneSight EssilorLuxottica Foundation, 13515 N. Stemmons Fwy.,\n            Dallas, TX 75234, Attn: Partnerships (if notice is sent by mail or\n            personal or courier delivery) and/or to\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "mailto:info@onesight.org"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("support@onesight.org")])])]), _vm._v("\n            (if notice is sent by electronic mail), or to such other person or\n            address as the Foundation may designate in writing to Participant\n            for this purpose. In order for notice to the Foundation to be\n            effective, a copy of such notice must be sent to OneSight\n            EssilorLuxottica Foundation, Attn: General Counsel, at the\n            Foundation address designated above (if notice is sent by mail or\n            personal or courier delivery). Notices delivered hereunder shall\n            be effective when received or refused. Notwithstanding the\n            foregoing, (i) written approvals and authorizations required\n            hereunder may be provided facsimile, email, or other written\n            means; and (ii) the Foundation may notify Participant, including\n            notice of any change to the CLTL Program or the terms of the\n            Contract, by posting a notice on the Portal.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Entire Agreement:")]), _vm._v(" Except as expressly and\n            specifically provided in this Contract, this Contract supersedes\n            any prior understandings or oral agreements between the parties\n            regarding the subject matter hereof and constitutes the entire\n            understanding and agreement of such parties with respect to the\n            subject matter hereof.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Force Majeure:")]), _vm._v(" The obligations of any party under\n            this Contract will be suspended for the duration of any force\n            majeure applicable to that party. The term \"force majeure\" means\n            any cause not reasonably within the control of the party claiming\n            suspension, including an act of God, industrial disturbance,\n            supplier disruptions, war, riot, weather-related disaster,\n            earthquake and governmental action. The party claiming suspension\n            under this Section will take reasonable steps to resume\n            performance as soon as possible without incurring unreasonably\n            excessive costs.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Miscellaneous:")]), _vm._v(" The failure of a party at any time\n            to require performance of any provision of or resort to any remedy\n            provided under this Contract shall in no way affect the right of\n            that party to require performance or resort to a remedy at any\n            time thereafter, nor shall the waiver by a party of a breach be\n            deemed to be a waiver of any subsequent breach. A waiver shall not\n            be effective unless it is in writing and signed by the party\n            against whom the waiver is being enforced. If any term or\n            provision of this Contract is determined to be invalid, illegal,\n            or incapable of being enforced by any law, regulation, or public\n            policy,"), _c('span', {
    staticStyle: {
      "line-height": "115%",
      "font-family": "Aptos",
      "font-size": "10pt"
    }
  }), _vm._v("then such provision will be interpreted, construed, or reformed\n            to the extent reasonably required to render the same valid,\n            enforceable and consistent with the original intent underlying\n            such provision, and all other terms and provisions of this\n            Contract shall nevertheless remain in full force and effect.\n            Notwithstanding the foregoing, if any such modification causes a\n            material change in the obligations or rights of any party, upon\n            written notice from one party to the other of the adverse effect\n            thereof upon such notifying party, and then if the parties are not\n            able to mutually agree as to an amendment hereto, any party may\n            terminate this Contract upon thirty (30) days written notice to\n            the other parties.This Contract shall not be altered, amended, or\n            modified in any way except by (i) a written instrument dated\n            subsequent to the date of this Contract and signed on behalf of\n            the parties by their respective duly authorized representatives;\n            or (ii) a subsequent “clickwrap” agreement made available by the\n            Foundation on the Portal to which Participant has indicated\n            Participant’s assent by clicking an “I Agree” or “Submit” or\n            similar button. Section captions and headings are for are for\n            reference purposes only and shall not control or affect the\n            construction or interpretation of this Contract in any\n            respect.  In all cases, the use of \"includes/ing\" shall mean\n            \"includes/ing without limitation\".\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "0pt",
      "margin-bottom": "0pt",
      "text-align": "justify"
    }
  }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
    staticClass: "terms-section mt-4"
  }, [_vm._v("Business Associate Agreement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12pt",
      "margin-bottom": "0pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("This HIPAA Business Associate Agreement (\"Agreement\") supplements\n            and is made a part of the Changing Life through Lenses® Agreement\n            (\"CLTL Contract\") by and between the legal entity or individual\n            identified as the participant on the Champions for Sight®\n            registration form (referred to herein as “Covered Entity\") and\n            OneSight d/b/a OneSight EssilorLuxottica Foundation (referred to\n            herein as \"Business Associate\"), and is effective as of the\n            Effective Date of the CLTL Contract between the parties, as\n            defined in the Changing Life through Lenses® Terms and\n            Conditions.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("RECITALS")])])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Business Associate provides certain services to health care\n              providers; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Business Associate has been retained by Covered Entity to\n              perform functions or activities that will require the Business\n              Associate to have access to or create, receive, maintain or\n              transmit Protected Health Information in relation to the Covered\n              Entity; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", Pursuant to the Health Insurance Portability and\n              Accountability Act of 1996 (\"HIPAA\"), Covered Entity and\n              Business Associate desire to execute this Agreement to comply\n              with the terms of the Privacy Rule, the Security Rule and the\n              HITECH Act under the American Recovery and Reinvestment Act of\n              2009 (as defined below); and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", this Agreement has been drafted to incorporate the provisions\n              required by the final regulations issued by the Department of\n              Health and Human Services on January 25, 2013 implementing the\n              HITECH Act; and")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("WHEREAS,")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("\n              Business Associate acts in the capacity of an independent\n              contractor in relation to the services provided to Covered\n              Entity under the CLTL Contract.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "9.6pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "8.4pt",
      "font-family": "serif",
      "font-size": "10pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v("NOW, THEREFORE")])]), _c('span', {
    staticStyle: {
      "font-family": "Arial",
      "font-size": "11pt"
    }
  }, [_vm._v(", in consideration of the mutual covenants, terms and\n              conditions herein contained, the parties hereto agree as\n              follows:")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("1) DEFINITIONS")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("Terms used but not otherwise defined in the Agreement shall have\n            the same meaning as those terms in the Privacy Rule and Security\n            Rule.")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Breach\"")]), _vm._v(" shall have the meaning given to it\n            by 45 CFR Section 164.402.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Breach Notification Rule\"")]), _c('strong', [_vm._v(" ")]), _vm._v("shall mean the Standards for Breach\n            Notification for Unsecured Protected Health Information under\n            HIPAA that is codified at 45 CFR Parts 160 and 164,\n            subparts A and D.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Deidentified Data\"")]), _vm._v(" shall have the same\n            meaning as the term \"deidentified data\" in 45 CFR\n            Section 164.514.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Designated Record Set\"")]), _vm._v(" shall mean a group\n            of records maintained by or for a Covered Entity that is:\n            (i) the medical records and billing records about Individuals\n            maintained by or for a covered health care provider; (ii) the\n            enrollment, payment, claims adjudication, and case or medical\n            management record systems maintained by or for a health plan; or\n            (iii) used, in whole or in part, by or for the Covered Entity\n            to make decisions about Individuals. For purposes of this\n            definition, the term \"record\" means any item, collection, or\n            grouping of information that includes Protected Health Information\n            and is maintained, collected, used, or disseminated by or for a\n            Covered Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Health Care Operations\"")]), _vm._v(" shall have the same\n            meaning as the term \"Health Care Operations\" in 45 CFR\n            Section 164.501.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"HITECH Act\"")]), _vm._v(" shall mean the provisions of\n            Title XIII, Subtitle D of the American Recovery and\n            Reinvestment Act of 2009. Any reference to a section of the HITECH\n            Act shall also include any HITECH Regulations related thereto.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"HITECH Regulations\"")]), _vm._v(" shall mean any guidance\n            issued relating to the HITECH Act by the Department of Health and\n            Human Services, including the Breach Notification Rule.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Individual\"")]), _vm._v(" shall have the same meaning as\n            the term \"individual\" in 45 CFR Section 160.103 and\n            shall include a person who qualifies as a personal representative\n            in accordance with 45 CFR Section 164.502(g).\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Privacy Rule\"")]), _vm._v(" shall mean the Standards for\n            Privacy of Individually Identifiable Health Information that is\n            codified at 45 CFR Parts 160 and 164, subparts A\n            and E.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Protected Health Information\"")]), _vm._v(" or "), _c('strong', [_vm._v("\"PHI\"")]), _vm._v(" shall mean any\n            information, whether oral or recorded in any form or medium:\n            (i) that relates to the past, present or future physical or\n            mental condition of an individual; the provision of health care to\n            an individual; or the past, present or future payment for the\n            provision of health care to an individual; and (ii) that\n            identifies the individual or with respect to which there is a\n            reasonable basis to believe the information can be used to\n            identify the individual, and shall have the meaning given to such\n            term under 45 CFR Section 160.103. Protected Health\n            Information shall be limited to the information created or\n            received by Business Associate from or on behalf of Covered\n            Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Required By Law\"")]), _vm._v(" shall have the same\n            meaning as the term \"required by law\" in 45 CFR\n            Section 164.103.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Secretary\"")]), _vm._v(" shall mean the Secretary of the\n            Department of Health and Human Services or his or her designee.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Security Rule\"")]), _vm._v(" shall mean the Security\n            Standards for the Protection of Electronic Protected Health\n            Information under HIPAA that is codified at 45 CFR\n            Parts 160 and 164, subparts A and C.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("\"Unsecured PHI\"")]), _vm._v(" shall mean Protected Health\n            Information that is not secured through the use of a technology or\n            methodology that renders such Protected Health Information\n            unusable, unreadable or indecipherable to unauthorized\n            individuals, as specified in guidance issued pursuant to\n            Section 13402(h) of the HITECH Act, including the Breach\n            Notification Rule.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("2) OBLIGATIONS AND ACTIVITIES OF BUSINESS ASSOCIATE")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Permitted Uses and Disclosures")]), _vm._v(". Business\n            Associate agrees to not use or disclose Protected Health\n            Information other than as permitted or required by this Agreement\n            or as Required By Law. Business Associate shall not use or\n            disclose Protected Health Information in any manner that violates\n            the Privacy Rule or the HITECH Act. To the extent required by the\n            Privacy Rule, Business Associate shall only request, use and/or\n            disclose the minimum amount of Protected Health Information\n            necessary to accomplish the purpose of the request, use and/or\n            disclosure. The determination of what constitutes the minimum\n            necessary amount of Protected Health Information shall be\n            determined in accordance with the provisions of the Privacy Rule.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Safeguards")]), _vm._v(". Business Associate agrees to use\n            administrative, physical and technical safeguards applicable to\n            the services provided under the CLTL Contract that reasonably and\n            appropriately protect the confidentiality, integrity and\n            availability of Protected Health Information, in electronic or any\n            other form, that it creates, receives, maintains or transmits\n            under this Agreement, in accordance with the Privacy Rule and the\n            Security Rule to prevent the use or disclosure of Protected Health\n            Information other than as provided for by this Agreement. Business\n            Associate shall fully comply with the Security Rule with regard to\n            electronic Protected Health Information.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Reporting of Improper Use or Disclosure")]), _vm._v(". Business\n            Associate agrees to report to the Covered Entity any use or\n            disclosure of the Protected Health Information not provided for by\n            this Agreement of which it becomes aware. Business Associate shall\n            also report any security incident of which it becomes aware to\n            Covered Entity. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Mitigation.")]), _vm._v(" Business Associate agrees to\n            mitigate, to the extent practicable, any harmful effect that is\n            known to Business Associate of a use or disclosure of Protected\n            Health Information by Business Associate in violation of the\n            requirements of this Agreement. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Agents and Subcontractors.")]), _vm._v(" Business\n            Associate agrees to require that any agents or subcontractors that\n            create, receive, maintain or transmit Protected Health Information\n            on behalf of Business Associate in relation to Covered Entity\n            agree in writing (in the form of a business associate contract) to\n            substantially similar restrictions, conditions and requirements\n            that apply through this Agreement to Business Associate with\n            respect to such information, including the implementation of\n            reasonable and appropriate measures for safeguarding Protected\n            Health Information. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Access to Individuals.")]), _vm._v(" To the extent\n            applicable, Business Associate agrees to provide access to\n            Protected Health Information in a Designated Record Set, to\n            Covered Entity or, as directed by Covered Entity, to an Individual\n            in order to meet the requirements under 45 CFR\n            Section 164.524. Further, if an Individual requests a copy of\n            Protected Health Information in a specific electronic format,\n            Business Associate shall comply with such request, if readily\n            producible, in accordance with the requirements of 45 CFR Section\n            164.524.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Amendments to Protected Health Information.")]), _vm._v(" To the extent applicable, Business Associate agrees to make\n            any reasonable amendment(s) to Protected Health Information in a\n            Designated Record Set that the Covered Entity directs or agrees to\n            pursuant to 45 CFR Section 164.526 at the request of Covered\n            Entity or an Individual.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Access to Internal Practices, Books and Records.")]), _vm._v(" Business Associate agrees to make internal practices, books\n            and records including policies and procedures and Protected Health\n            Information, relating to the use and disclosure of Protected\n            Health Information received from, or created or received by\n            Business Associate on behalf of, Covered Entity available to the\n            Secretary for purposes of the Secretary determining Covered\n            Entity's compliance with HIPAA.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Disclosure Documentation.")]), _vm._v(" Business Associate\n            agrees to document such disclosures of Protected Health\n            Information and information related to such disclosures as would\n            be required for Covered Entity to respond to a request by an\n            Individual for an accounting of disclosures of Protected Health\n            Information in accordance with 45 CFR Section 164.528.\n            Business Associate agrees to provide to Covered Entity or an\n            Individual information collected in accordance with this\n            subsection to permit Covered Entity to respond to a request by an\n            Individual for an accounting of disclosures of Protected Health\n            Information in accordance with 45 CFR Section 164.528.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Obligation Upon Breach of Unsecured PHI.")]), _c('strong', [_vm._v(" ")]), _vm._v("Upon Business Associate's discovery of a\n            Breach of Unsecured PHI, Business Associate shall provide notice\n            of the Breach to Covered Entity in accordance with the\n            requirements of 45 CFR 164.410. The content of such written notice\n            of the Breach shall comply with the requirements of 45 CFR\n            Section 164.410(c). Business Associate shall cooperate with\n            and coordinate an appropriate course of action with Covered\n            Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Delegated Obligations")]), _vm._v(". To the extent Business\n            Associate is to carry out one or more of Covered Entity’s\n            obligations under Subpart E of 45 CFR Part 164, Business Associate\n            agrees to comply with the requirements of Subpart E that apply to\n            Covered Entity in the performance of such obligations.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("3) PERMITTED USES BY BUSINESS ASSOCIATE")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Service Agreement.")]), _vm._v(" Except as otherwise\n            limited in this Agreement, Business Associate may use or disclose\n            Protected Health Information to perform functions, activities, or\n            services for, or on behalf of, Covered Entity as specified in the\n            CLTL Contract, provided that such use or disclosure would not\n            violate the Privacy Rule if done by Covered Entity.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "margin-bottom": "12pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Other Permitted Usage.")]), _vm._v(" Except as otherwise\n            limited in this Agreement, Business Associate may use Protected\n            Health Information for the proper management and administration of\n            the Business Associate or to carry out the legal responsibilities\n            of the Business Associate. Business Associate may disclose\n            Protected Health Information for the proper management and\n            administration of the Business Associate if the disclosure is\n            Required by Law or Business Associate obtains reasonable\n            assurances from the person to whom the information is disclosed\n            that it will be held confidentially and used or further disclosed\n            only as Required by Law or for the purposes for which it was\n            disclosed to the person and the person notifies Business Associate\n            of any instances of which it is aware in which the confidentiality\n            of the information has been breached.  In addition, Business\n            Associate may use Protected Health Information to provide Data\n            Aggregation services as permitted by 45 CFR\n            Section 164.504(e)(2)(i)(B) and/or to create Limited Data\n            Sets as permitted by 45 CFR 164.514(e).\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-left": "36pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("The Business Associate’s activities will require access to\n            Protected Health Information to process prescriptions placed by\n            the Covered Entity pursuant to the CLTL Contract. Also, Business\n            Associate may also facilitate certain treatment activities (as\n            defined at 45 CFR 164.501) and perform certain health care\n            operation functions (as defined at 45 CFR 164.501), including\n            conducting certain audit functions, on behalf of the Covered\n            Entity.")]), _c('br'), _c('br'), _c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("Further, Covered Entity expressly agrees to provide Business\n            Associate with Protected Health Information, as requested by\n            Business Associate from time to time, so that Business Associate\n            may create a limited data set with such information that complies\n            with the requirements of 45 CFR 164.514(e). After creating the\n            limited data set, Business Associate will conduct research on the\n            limited data set, as allowed under 45 CFR 164.514(e)(3). The\n            Business Associate will not use or further disclose the limited\n            data set information in a manner that would violate the\n            requirements of the Privacy Rule. In relation to the limited data\n            set information maintained by Business Associate, Business\n            Associate will use appropriate safeguards to prevent use or\n            disclosure of the information other than as provided for by this\n            Agreement; report to the Covered Entity any use or disclosure of\n            the information not provided for by this Agreement of which it\n            becomes aware; ensure that any agents to whom it provides the\n            limited data set agree to the same restrictions and conditions\n            that apply to the limited data set recipient with respect to such\n            information; and not identify the information or contact the\n            individuals, in accordance with the requirements of 45 CFR\n            164.514(e)(4)(ii)(C).")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("4) OBLIGATIONS OF COVERED ENTITY")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Change in Privacy Practices.")]), _vm._v(" Covered Entity\n            shall notify Business Associate of any limitation(s) in its notice\n            of privacy practices of Covered Entity in accordance with 45 CFR\n            Section 164.520, to the extent that such limitation may affect\n            Business Associate's use or disclosure of Protected Health\n            Information. Additionally, Covered Entity shall notify Business\n            Associate of any limitation(s) or restriction(s) in its security\n            practices to the extent that such limitation may affect Business\n            Associate's use or disclosure of Protected Health Information.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("No Restrictions on the Use or Disclosure of Protected Health\n              Information.")]), _vm._v(" Covered Entity shall not agree to an Individual’s request\n            to restrict uses or discloses of Protected Health Information, to\n            the extent that such changes may affect Business Associate's\n            ability to perform the functions described in the CLTL Contract,\n            including this Agreement. Because of the charitable nature of the\n            services performed in relation to the Covered Entity’s patients\n            whose PHI is subject to this Agreement, 45 CFR 164.522(a)(1)(vi)\n            will not apply to the PHI of such patients since such patients are\n            not paying in full for services performed. Therefore, the Covered\n            Entity is allowed under 45 CFR 164.522(a)(1)(ii) to not agree, and\n            shall not agree, to any restriction requested by an Individual\n            whose PHI will be shared with Business Associate as part of the\n            services provided under the CLTL Contract. \n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("5) PERMISSIBLE REQUESTS BY COVERED ENTITY")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("\n            Covered Entity shall not request Business Associate to use or\n            disclose Protected Health Information in any manner that would not\n            be permissible under the Privacy Rule if done by Covered Entity.\n          ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("6) TERM AND TERMINATION")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Term.")]), _vm._v(" This Agreement will begin on the\n            Effective Date and will continue until terminated in accordance\n            herein.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Termination. ")]), _vm._v("In addition to the termination\n            rights set forth in the Terms and Conditions, a party may\n            terminate the Agreement as follows: \n            "), _c('ol', {
    staticStyle: {
      "margin-right": "0pt",
      "margin-left": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Termination for Cause.")]), _vm._v(" Upon Covered\n                Entity's knowledge of a material breach of this Agreement by\n                Business Associate, Covered Entity shall provide not less than\n                20 days written notice of its intent to terminate the\n                Agreement if Business Associate does not cure such material\n                breach no later than the end of the written notice period. If\n                Business Associate does not cure the breach within such time,\n                then Covered Entity may, in its sole discretion, immediately\n                terminate this Agreement.\n              ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Termination without Cause and Termination of the CLTL\n                  Contract. ")]), _vm._v("Either party may terminate this Agreement effective upon 15\n                days advance written notice to the other party given with or\n                without any reason if Business Associate no longer performs\n                services for Covered Entity requiring the use or disclosure of\n                Protected Health Information. This Agreement will immediately\n                terminate if the CLTL Contract terminates. The effective date\n                of such termination will be the same as the effective date\n                that the CLTL Contract terminates.\n              ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Effect of Termination.")]), _vm._v(" Unless otherwise\n                mutually agreed by the parties, the termination of this\n                Agreement for any reason shall automatically terminate the\n                CLTL Contract. The parties mutually agree in advance that\n                returning or destroying Protected Health Information upon\n                termination of this Agreement is infeasible. Therefore,\n                Business Associate shall extend the protections of this\n                Agreement to such Protected Health Information and limit\n                further uses and disclosures of such Protected Health\n                Information to those purposes that make the return or\n                destruction infeasible, for so long as Business Associate\n                maintains such Protected Health Information.\n              ")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "14pt",
      "margin-bottom": "14pt",
      "text-align": "justify",
      "line-height": "normal",
      "background-color": "#ffffff"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_vm._v("7) MISCELLANEOUS")])])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Regulatory References.")]), _vm._v(" Any reference in this\n            Agreement to a section in the Privacy Rule, Security Rule, Breach\n            Notification Rule or HITECH Act means the section as in effect or\n            as amended.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Amendment.")]), _vm._v(" The Parties agree to take such\n            action as is necessary to amend this Agreement from time to time\n            as is necessary for Covered Entity to comply with the requirements\n            of the Privacy Rule, Security Rule, the Breach Notification Rule\n            or any other requirements of the HITECH Act.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Survival.")]), _vm._v(" The respective rights and\n            obligations of Business Associate under Section 6.2.3 shall\n            survive the termination of this Agreement.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Interpretation; Conflict.")]), _vm._v(" Any ambiguity in\n            this Agreement shall be resolved to permit both parties to comply\n            with the Privacy Rule, Security Rule, the Breach Notification Rule\n            or any other requirements of the HITECH Act. \n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("No Third-Party Beneficiaries.")]), _vm._v(" Except as set\n            forth in this Agreement or as expressly provided for under HIPAA,\n            this Agreement is entered into by and among the parties hereto\n            solely for their benefit. The parties have not created or\n            established any third-party beneficiary status or rights in any\n            person or entity not a party hereto including any individual,\n            provider, subcontractor, or other third-party, and no such\n            third-party will have any right to enforce any right or enjoy any\n            benefit created or established under this Agreement.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Force Majeure.")]), _vm._v(" The obligations of any party\n            under this Agreement will be suspended for the duration of any\n            force majeure applicable to that party. The term \"force majeure\"\n            means any cause not reasonably within the control of the party\n            claiming suspension, including an act of God, industrial\n            disturbance, supplier disruptions, war, riot, weather-related\n            disaster, earthquake and governmental action. The party claiming\n            suspension under this Section will take reasonable steps to resume\n            performance as soon as possible without incurring unreasonably\n            excessive costs.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Entire Agreement.")]), _vm._v(" This Agreement including\n            any riders, attachments or amendments hereto, constitutes the\n            entire agreement among the parties with respect to the Privacy\n            Rule, the Security Rule, the Breach Notification Rule and any\n            other requirements of the HITECH Act. This Agreement supersedes\n            any prior agreement or understandings pertaining to HIPAA\n            obligations between the parties, whether oral or written.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Disputes; Choice of Law.")]), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Any disputes between the parties related to this Agreement\n                shall be governed by the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('strong', [_c('u', [_vm._v(", including, to the extent applicable, the Agreement to\n                Arbitrate set forth in the “Disputes with OneSight\n                EssilorLuxottica Foundation” section of the\n              ")])]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _c('u', [_vm._v(".")]), _vm._v(" If and to the extent the\n            "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.evfusa.org/terms-and-conditions/",
      "target": "_blank"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("Terms of Use")])])])]), _vm._v("\n            are determined not to apply to a dispute between the parties, (i)\n            this Agreement shall be governed by and construed in accordance\n            with the laws of the state of Texas, without regard to principles\n            of conflict or choice of law; and (ii) any dispute arising out of\n            or in connection with this Agreement shall be filed and heard in\n            the state or federal courts located in Dallas, Texas, and the\n            parties consent to the exclusive jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Assignment and Delegation.")]), _vm._v(" No party may\n            assign this Agreement, or any rights or obligations hereunder,\n            without the prior written consent of the other party. Any attempt\n            to assign this Agreement in contravention of this Section shall be\n            void and of no force and effect. This Agreement is binding upon\n            and will inure to the benefit of the respective parties hereto and\n            their successors and permitted assigns.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Notices.")]), _vm._v(" Any notice required pursuant to\n            this Agreement shall comply with the requirements for notices as\n            set forth in the OneSight EssilorLuxottica Foundation Changing\n            Life through Lenses® Terms and Conditions that form part of the\n            CLTL Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal",
      "letter-spacing": "0.1pt",
      "color": "#444444"
    }
  }, [_c('strong', [_vm._v("Miscellaneous.")]), _vm._v(" The failure of a party at any time\n            to require performance of any provision of or resort to any remedy\n            provided under this Agreement shall in no way affect the right of\n            that party to require performance or resort to a remedy at any\n            time thereafter, nor shall the waiver by a party of a breach be\n            deemed to be a waiver of any subsequent breach. A waiver shall not\n            be effective unless it is in writing and signed by the party\n            against whom the waiver is being enforced. If any term or\n            provision of this Agreement is determined to be invalid, illegal,\n            or incapable of being enforced by any law, regulation, or public\n            policy, then such provision will be interpreted, construed or\n            reformed to the extent reasonably required to render the same\n            valid, enforceable and consistent with the original intent\n            underlying such provision, and all other terms and provisions of\n            this Agreement shall nevertheless remain in full force and effect.\n            Notwithstanding the foregoing, if any such modification causes a\n            material change in the obligations or rights of any party, upon\n            written notice from one party to the other of the adverse effect\n            thereof upon such notifying party, and then if the parties are not\n            able to mutually agree as to an amendment hereto, any party may\n            terminate this Agreement upon thirty (30) days written notice to\n            the other parties. This Agreement shall not be altered, amended or\n            modified in any way except by (i) a written instrument dated\n            subsequent to the date of this Agreement and signed on behalf of\n            the parties by their respective duly authorized representatives;\n            or (ii) a subsequent “clickwrap” agreement made available by the\n            Foundation on the OneSight EssilorLuxottica Foundation Changing\n            Life through Lenses® online platform to which Covered Entity has\n            indicated Covered Entity’s assent by clicking an “I Agree” or\n            “Submit” or similar button. Section captions and headings are for\n            are for reference purposes only and shall not control or affect\n            the construction or interpretation of this Agreement in any\n            respect. In all cases, the use of \"includes/ing\" shall mean\n            \"includes/ing without limitation\".\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "terms-section mt-5"
  }, [_vm._v("Grateful Patient™ Agreement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "12pt",
      "margin-bottom": "4pt",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Grateful Patient™ Point of Sale Giving Campaign Terms and\n            Conditions")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "margin": "0pt",
      "padding-left": "0pt"
    },
    attrs: {
      "type": "1"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Definitions; Effective Date. ")]), _vm._v("These Grateful\n            Patient™ Point of Sale Giving Terms and Conditions (“"), _c('strong', [_vm._v("Grateful Patient™ Terms and Conditions")]), _vm._v("”) supplement and are made part of the Grateful Patient™ ™ Point\n            of Sale Agreement (“"), _c('strong', [_vm._v("Grateful Patient™ Contract")]), _vm._v("”)\n            by and between the legal entity or individual identified as the\n            participant (“"), _c('strong', [_vm._v("Participant")]), _vm._v("”) on the Champions for\n            Sight registration form (“"), _c('strong', [_vm._v("Registration Form")]), _vm._v("”) and\n            these Terms and Conditions, and OneSight d/b/a OneSight\n            EssilorLuxottica Foundation (“"), _c('strong', [_vm._v("Foundation")]), _vm._v("”).\n            Capitalized terms used but not defined in these Grateful Patient™\n            Terms and Conditions shall have the meaning ascribed to them in\n            the Registration Form. If you accept this Grateful Patient™\n            Contract, the date on which you click the “Agree & Submit” or\n            similar button shall be the effective date of the Grateful\n            Patient™ Contract (“"), _c('strong', [_vm._v("Effective Date")]), _vm._v("”).\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Information.")]), _c('strong', [_vm._v(" ")]), _vm._v(" The\n            Foundation has created the Grateful Patient™ Program, a charitable\n            point of sale (“"), _c('strong', [_vm._v("POS")]), _vm._v("”) fundraising program (the\n            “"), _c('strong', [_vm._v("Grateful Patient™")]), _vm._v(" "), _c('strong', [_vm._v("Program")]), _vm._v("”) for\n            independent eyecare professionals and businesses. The purpose of\n            the Grateful Patient™ Program is to raise funds for the benefit of\n            The Foundation, whose mission is to eliminate poor vision in a\n            generation. Participant can elect to participate in the Grateful\n            Patient™ by making available to Participant’s customers at\n            Participant’s locations in the United States information enabling\n            customers to make a direct donation to the Foundation and/or the\n            option to make a donation to The Foundation during the POS\n            checkout process (“"), _c('strong', [_vm._v("POS Donations")]), _vm._v("”), as more fully\n            described in these Terms and Conditions. Except as otherwise\n            expressly provided herein, Participant shall be solely responsible\n            for all costs of operating the Grateful Patient™ Program,\n            including the costs of acquiring and maintaining any POS hardware\n            and software. Participant shall direct customer inquiries or\n            concerns regarding The Foundation or the Grateful Patient™ Program\n            to The Foundation at 1-866-385-0447.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Program Materials.")]), _c('strong', [_vm._v(" ")]), _vm._v(" "), _c('strong', [_vm._v("Participant agrees to print out and prominently display to its\n              customers a copy of The Foundation’s then-current disclosures\n              related to the solicitation of donations, which can be found at: ")]), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/disclosures"
    }
  }, [_c('strong', [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/disclosures")])])])]), _c('strong', [_vm._v(".")]), _vm._v(" In addition, upon Participant’s request, The\n            Foundation will provide Participant with a digital template of\n            promotional materials for purposes of publicizing the Grateful\n            Patient™ Program (\""), _c('strong', [_vm._v("Grateful Patient™ Program Materials")]), _vm._v("”). Participant shall be responsible for all costs of printing\n            Grateful Patient™ Program Materials supplied in digital formats.\n            From time to time, The Foundation may offer printed Grateful\n            Patient™ Program Materials. The Foundation may impose a fee for\n            printed Grateful Patient™ Program Materials and will inform\n            Participant of the amount of such fee prior to fulfilling\n            Participant’s request for Grateful Patient™ Program Materials.\n            Participant shall use Grateful Patient™ Program Materials solely\n            in connection with the Grateful Patient™ Program. Participant\n            shall not transfer the Grateful Patient™ Program Materials or its\n            right to use the Grateful Patient™ Program Materials to any third\n            party. Participant shall use Grateful Patient™ Program Materials\n            as is and shall not modify Grateful Patient™ Program Materials in\n            any way without the express written approval of The Foundation;\n            provided, however, that where Grateful Patient™ Program Materials\n            provide a space expressly for co-branding by Grateful Patient™\n            Program participants, Participant may add Participant’s business\n            logo to such space. Participant shall not delete, obscure, or\n            alter any disclosures or any copyright notice, trademarks, or\n            other proprietary rights notices affixed to or contained in the\n            Grateful Patient™ Program Materials. Upon termination of the\n            Grateful Patient™ Contract, Participant shall immediately cease\n            use of the Grateful Patient™ Program Materials and destroy all\n            Grateful Patient™ Program Materials in Participant’s possession.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("OneSight EssilorLuxottica Foundation Marks. ")]), _vm._v("Participant acknowledges The Foundation’s right, title and\n            interest in its trade names, trademark, trade dress, logos, and\n            other indicia of origin owned or licensed by The Foundation (the\n            “"), _c('strong', [_vm._v("Foundation Marks")]), _vm._v("”). Participant is authorized to\n            use non-exclusively the Foundation Marks solely as the Foundation\n            Marks are incorporated into the Grateful Patient™ Program\n            Materials and shall not use the Foundation Marks for any other\n            purpose.\n            "), _c('a', {
    attrs: {
      "name": "_Hlk173319593"
    }
  }, [_vm._v("Participant shall not transfer, sublicense, or assign its\n              rights to use the Grateful Patient™ Program Marks")]), _vm._v(". Participant acknowledges and agrees that The Foundation or its\n            licensor, as applicable, retains all ownership rights in and to\n            the Foundation Marks and that the benefit of use of the Foundation\n            Marks hereunder, as well as all trademark and other intellectual\n            property rights stemming therefrom, shall inure and belong solely\n            to The Foundation or its licensor, as applicable. Participant\n            agrees to cease use of the Foundation Marks immediately upon\n            termination of this Grateful Patient™ Contract or sooner upon The\n            Foundation’s request.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "margin-bottom": "8pt",
      "text-align": "justify",
      "line-height": "108%",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("POS Donations.")]), _vm._v(" In order to support participation\n            in the Grateful Patient™ Program, The Foundation has identified a\n            number of merchant providers/donation tactics to enable\n            Participant to accept POS Donations in the manner best suited to\n            Participant’s practice.  Depending on Participant’s chosen\n            merchant provider/donation tactic, Participant may incur fees,\n            charges and/or costs (collectively, “"), _c('strong', [_vm._v("POS Fees")]), _vm._v("”)\n            of participating in the Grateful Patient™ Program, including POS\n            Fees associated with credit card transactions processed in\n            connection with the Grateful Patient™ Program, including\n            processing fees, authorization fees, chargeback fees, or any other\n            related expenses. Unless otherwise expressly agreed by The\n            Foundation in writing, The Foundation shall not be responsible or\n            liable for any such POS Fees, and all such POS Fees shall be the\n            sole responsibility of Participant. This Section is not intended\n            to amend preexisting written agreements in which The Foundation\n            and Participant have agreed upon specific POS Fees. Participant\n            may either (a) if available, acquire from one or more suppliers\n            designated by The Foundation from time to time (each a “"), _c('strong', [_vm._v("Designated Supplier")]), _vm._v("”) specially configured equipment, software, and payment\n            processing services (collectively, “"), _c('strong', [_vm._v("Designated Supplier Equipment/Services")]), _vm._v("”) or (b) use Participant’s own POS system.\n            "), _c('strong', [_vm._v("The Foundation does not warrant or endorse Designated Suppliers\n              or Designated Supplier Equipment/Services and Participant’s use\n              of any Designated Supplier Equipment/Services shall be at\n              Participant’s own risk and subject to a separate agreement(s)\n              between Participant and one or more Designated\n              Suppliers.")]), _vm._v("\n            If Participant does not use Designated Supplier\n            Equipment/Services, Participant shall: (i) create a separate stock\n            keeping unit (“"), _c('strong', [_vm._v("SKU")]), _vm._v("”) to be used exclusively for\n            POS Donations, (ii) allow customers to make a donation at checkout\n            by any method of payment customarily accepted by Participant for\n            purchases (but excluding private or public insurance and\n            promotional coupons or offers); and (iii) issue a written receipt\n            to the customer indicating the donation SKU number, the fact that\n            the SKU represents a donation to OneSight EssilorLuxottica\n            Foundation, the amount of the donation, and the date of the\n            donation. With respect to all POS Donations collected by\n            Participant, Participant shall deposit and safely and securely\n            hold all such POS Donations as trustee for the sole benefit of The\n            Foundation until they are remitted to The Foundation as provided\n            in Section 6 (Payment) below; provided, that Participant shall not\n            be required to maintain a segregated bank account for such POS\n            Donations. The Foundation shall be the sole and exclusive owner of\n            all POS Donations. Participant shall not use the POS Donations\n            other than as described in this Grateful Patient™ Contract.\n            Participant shall not allow the POS Donations to be assigned,\n            alienated, pledged, encumbered or subjected to attachment,\n            garnishment, levy, execution or other legal or equitable process\n            by a third party.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Payment.")]), _c('strong', [_vm._v(" ")]), _vm._v("No later than\n            thirty (30) days after the end of each month, Participant will\n            remit to The Foundation 100% of the POS Donations collected by\n            Participant during such month; provided, however, that Participant\n            shall have no obligation to remit to The Foundation any POS\n            Donations that cannot be processed (e.g., returned checks, credit\n            card chargebacks, etc.) or that are remitted by Designated\n            Suppliers. Payments shall be made in U.S. Dollars by (i) check\n            payable to OneSight EssilorLuxottica Foundation and sent to The\n            Foundation,"), _c('strong'), _vm._v("P.O. Box 637509, Cincinnati, OH\n            45263-7509; or (ii) electronic fund transfer (EFT) at Fifth Third\n            Bank 38 Fountain Square Plaza – MD 1090U9 Cincinnati, OH 45263\n            Routing #042000314 Account #7028939465; or (iii) online credit\n            card payment at www.championsforsight.org/portal/resources or by\n            using the custom link provided by The Foundation for online\n            payments. Together with each payment, Participant shall provide to\n            The Foundation an accounting of all POS Donations collected by\n            Participant during the applicable\n            "), _c('a', {
    attrs: {
      "name": "_Hlk173322765"
    }
  }, [_vm._v("period but excluding POS Donations remitted by Designated\n              Suppliers")]), _vm._v(". Participant agrees that any tax credit or tax deduction accrues\n            to the original donor and not to Participant, which is acting as a\n            third-party conveyer of the donation. POS Donations may be used as\n            The Foundation deems appropriate, in its sole discretion, in\n            furtherance of The Foundation’s charitable mission.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Records. ")]), _vm._v("During the Term and for two (2) years\n            thereafter, Participant shall (i) maintain complete and accurate\n            books and records of all activities conducted in connection with\n            the Grateful Patient™ Program and the collection and payment of\n            all POS Donations, and (ii) allow The Foundation to inspect, copy,\n            and/or audit such books and records.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("No Endorsement.")]), _c('strong', [_vm._v(" ")]), _vm._v("Participant\n            shall in no way suggest endorsement by The Foundation of\n            Participant or Participant’s products or services.\n            "), _c('strong', [_vm._v("The Foundation does not warrant or endorse Designated Supplier\n              Equipment/Services and Participant’s use of any Designated\n              Supplier Equipment/Services shall be at Participant’s own\n              risk.")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "32.17pt",
      "text-align": "justify",
      "line-height": "normal",
      "padding-left": "3.83pt"
    }
  }, [_c('strong', [_vm._v("Permission to Link.")]), _c('strong', [_vm._v(" ")]), _vm._v("During\n            the Term, The Foundation grants Participant permission to provide\n            a link from Participant’s website to The Foundation’s website. The\n            Foundation reserves the right to withdraw such permission at any\n            time and for any reason.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of The Foundation")]), _vm._v(".\n            The Foundation represents and warrants to Participant that it: (i)\n            has the right, power and authority to enter into this Grateful\n            Patient™  Contract; (ii) possesses sufficient rights to\n            provide the Grateful Patient™  Program Materials to\n            Participant and authorize the Participant’s use of The Foundation\n            Marks and the Grateful Patient™ Program Materials as set forth\n            herein; and (iii) is a nonprofit organization in good standing and\n            qualified for tax-exempt status under Section 501(c)(3) of the\n            Internal Revenue Code.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Representations and Warranties of Participant")]), _vm._v(".\n            Participant represents and warrants to The Foundation that it: (i)\n            has the right, power and authority to enter into this Grateful\n            Patient™ Contract; and (ii) will comply with all applicable\n            federal, state, and local laws, statutes, and regulations\n            (collectively, “"), _c('strong', [_vm._v("Laws")]), _vm._v("”) in connection with the\n            Grateful Patient™ Program and this Grateful Patient™ Contract,\n            including any Laws governing charitable solicitations and\n            fundraising.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Indemnity")]), _vm._v(". Participant agrees to indemnify and\n            hold The Foundation its directors, officers, employees, agents,\n            and volunteers harmless from and against any and all costs, losses\n            or expenses, including reasonable attorneys’ fees, that The\n            Foundation may incur by reason of any claims, actions, demands, or\n            law suits brought by a third party arising out of or in connection\n            with (i) Participant’s negligence, recklessness, or intentional\n            misconduct; (ii) Participant’s performance or failure to perform\n            pursuant to this Grateful Patient™ Contract, including breach of\n            any provision of this Grateful Patient™ Contract; or (iii)\n            Participant’s location(s), business, products, or services,\n            including any claims in the nature of product liability, personal\n            injury, or professional malpractice.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Term and Termination. ")]), _vm._v("This Grateful Patient™\n            Contract shall commence on the Effective Date and continue until\n            terminated as provided herein (the “"), _c('strong', [_vm._v("Term")]), _vm._v("”).\n            Either party may terminate this Grateful Patient™ Contract: (i)\n            upon a material breach of the Grateful Patient™ Contract by the\n            other party, if such breach is not remedied to the reasonable\n            satisfaction of the non-breaching party within fifteen (15) days\n            after the non-breaching party provides written notice of the\n            breach to the other party; (ii) immediately upon written notice to\n            the other party whenever the notifying party in its reasonable\n            discretion determines that the continuation of the Grateful\n            Patient™ Contract will damage its reputation or good will; (iii)\n            upon fifteen (15) days written notice for convenience; or (iv)\n            immediately upon written notice to Participant in the event The\n            Foundation discontinues the Grateful Patient™ Program. Upon\n            termination of this Grateful Patient™ Contract, Participant shall\n            immediately convey to The Foundation all Grateful Patient™ Program\n            Donations collected but not yet paid to The Foundation, cease to\n            use the Grateful Patient™ Program Materials and The Foundation\n            Marks, and discontinue references in any manner to its\n            relationship with The Foundation. The provisions of this Section\n            shall not preclude the parties from seeking any other remedies\n            available to them under this Grateful Patient™ Contract and\n            applicable law. The Sections regarding Payment, Records,\n            Indemnity, Governing Law and Venue, Notices, and Miscellaneous\n            shall survive termination of this Grateful Patient™ Contract. In\n            addition, any provision which would, by its nature, survive the\n            termination of this Grateful Patient™ Contract, shall do so.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Dispute Resolution; Governing Law and Venue")]), _vm._v(". In the event of any dispute arising out of this Grateful\n            Patient™ Contract, the parties shall use good faith efforts to\n            resolve their differences amicably. In the event they are\n            unsuccessful, the parties agree not to commence litigation until\n            attempting to resolve their dispute through mediation. Any party\n            may initiate the mediation process with thirty (30) days’ prior\n            written notice to the other party. The dispute shall be submitted\n            to mediation in New York, New York. Costs of mediation shall be\n            borne equally by the parties.  Mediation of the dispute shall\n            be completed within fifteen (15) days of commencement, unless the\n            parties extend the time by mutual agreement or unless the mediator\n            declares the parties to be at an impasse. Notwithstanding the\n            above, in the event that either party believes that immediate\n            injunctive relief is required to protect its Marks or other\n            intellectual property rights, such party may invoke the immediate\n            powers of the appropriate court of law, subject to this Section\n            15, without the requirement to first mediate the dispute. This\n            Grateful Patient™ Contract shall be governed by and construed in\n            accordance with the laws of the state of New York, without regard\n            to conflicts of law principles. Any dispute arising out of or in\n            connection with this Grateful Patient™ Contract that is not\n            resolved under the dispute resolution provisions of this Section\n            15 shall be filed and heard in the state or federal courts located\n            in the State of New York, and each party consents to the exclusive\n            jurisdiction of such courts.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Relationship of Parties.")]), _c('strong', [_vm._v(" ")]), _vm._v("The parties to this Grateful Patient™\n            Contract are not joint venturers, partners, agents, nor\n            representatives of each other, are not authorized to act on each\n            other’s behalf, and have no legal relationship other than as\n            independent contracting parties to this Grateful Patient™\n            Contract.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Assignment.")]), _c('strong', [_vm._v(" ")]), _vm._v("No party may\n            assign this Grateful Patient™ Contract, or any rights or\n            obligations hereunder, without the prior written consent of the\n            other party. Notwithstanding the foregoing, in the event that any\n            license agreement between The Foundation and its licensor is\n            terminated, The Foundation may, without Participant’s consent,\n            assign its rights and obligations with respect to any sublicense\n            granted hereunder to such licensor. Any attempt to assign this\n            Grateful Patient™ Contract in contravention of this Section shall\n            be void and of no force and effect.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Notices.")]), _c('strong', [_vm._v(" ")]), _vm._v("All notices\n            required or permitted to be given hereunder shall be in writing\n            and shall be sent by (i) personal delivery, (ii) reputable courier\n            service for prepaid overnight delivery, or (iii) USPS certified\n            mail, postage prepaid, return receipt requested. All notices to\n            Participant shall be forwarded to the contact person identified on\n            the Registration Form at the address listed for Participant on the\n            Registration Form or to such other person or address as\n            Participant may designate in writing to The Foundation for this\n            purpose. All notices to The Foundation shall be forwarded to\n            OneSight EssilorLuxottica Foundation, Attn: Giving Team, P.O. Box\n            637509, Cincinnati, OH 45263-7509 or to such other person or\n            address as The Foundation may designate in writing to Participant\n            for this purpose. In order for notice to The Foundation to be\n            effective, a copy of such notice must be sent to The Foundation,\n            Attn: General Counsel, at The Foundation address designated above.\n            Notices delivered hereunder shall be effective when received or\n            refused. Notwithstanding the foregoing, written approvals and\n            authorizations required hereunder may be provided by facsimile,\n            email, or other written means.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Entire Agreement.")]), _c('strong', [_vm._v(" ")]), _vm._v("This\n            Grateful Patient™ Contract supersedes any prior understandings or\n            oral agreements between the parties regarding the subject matter\n            hereof and constitutes the entire understanding and agreement of\n            such parties with respect to the subject matter hereof.\n            Notwithstanding the foregoing, your use of the OneSight\n            EssilorLuxottica Foundation website is also subject to the Terms\n            of Use ("), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/terms-of-use"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/terms-of-use")])])]), _vm._v(") and Privacy Policy ("), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.championsforsight.org/privacy-policy"
    }
  }, [_c('u', [_c('span', {
    staticStyle: {
      "color": "#467886"
    }
  }, [_vm._v("www.championsforsight.org/privacy-policy")])])]), _vm._v(") posted on the Champions of Site website portal; provided, that\n            in the event of any conflict between this Grateful Patient™\n            Contract and the Terms of Use and/or Privacy Policy, the\n            provisions of this Grateful Patient™  Contract shall prevail.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "text-align": "justify",
      "line-height": "normal"
    }
  }, [_c('strong', [_vm._v("Non-Exclusivity.")]), _c('strong', [_vm._v(" ")]), _vm._v("This\n            Grateful Patient™ Contract is a non-exclusive agreement which\n            reserves the rights of the parties to contract with third parties\n            for similar transactions.\n          ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "36pt",
      "margin-bottom": "8pt",
      "text-align": "justify",
      "line-height": "108%"
    }
  }, [_c('strong', [_vm._v("Miscellaneous.")]), _c('strong', [_vm._v(" ")]), _vm._v("The failure\n            of any party at any time to require performance of any provision\n            of, or resort to any remedy provided under, this Grateful Patient™\n            Contract shall in no way affect the right of that party to require\n            performance or resort to a remedy at any time thereafter, nor\n            shall the waiver by any party of a breach be deemed to be a waiver\n            of any subsequent breach. A waiver shall not be effective unless\n            it is in writing and signed by the party against whom the waiver\n            is being enforced. If any term or provision of this Grateful\n            Patient™ Contract is determined to be invalid, illegal, or\n            incapable of being enforced by any law, regulation, or public\n            policy, all other terms and provisions of this Grateful Patient™\n            Contract shall nevertheless remain in full force and effect. This\n            Grateful Patient™ Contract shall not be altered, amended or\n            modified in any way except by a written instrument dated\n            subsequent to the date of this Grateful Patient™ Contract and\n            signed on behalf of the parties by their respective duly\n            authorized representatives. Section captions and headings are for\n            are for reference purposes only and shall not control or affect\n            the construction or interpretation of this Grateful Patient™\n            Contract in any respect. The word “including” means “including,\n            but not limited to.”\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "type": "I"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/CLTLTermsAndConditions1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Terms and Conditions to the Changing Life through Lenses®\n                Agreement\n              ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/BusinessAssociateAgreement1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Business Associate Agreement (BAA) ")]), _vm._v("(collectively, the \"Contract\")\n            ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://files.championsforsight.org/GratefulPatients1024.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                Terms and Conditions to Point of Sale Giving\n              ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62833713", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62833713"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/TermAgreementAndBaa.vue
// module id = 532
// module chunks = 4